export default __webpack_public_path__ + "static/media/desmosandgeogebra.1b51f8f5.png";